import { ChangeDetectorRef, Component, Input, ViewContainerRef } from '@angular/core';
import { AngularComponentFactory, QuestionAngular } from 'survey-angular-ui';
import { DetailsListWidgetModel } from './details-list.widget.model';
import { RendererFactory } from 'survey-core';
import { FormBuilder } from '@angular/forms';
import { SurveyService } from '../../../../core/services/survey/survey.service';
import { VariablesService } from '../../../../core/services/survey/variables.service';
import { TangillaQuestion } from '../tangilla-question';
import { QuestionsService } from '../../../../core/services/survey/questions.service';
import { OfficesApiService, MemberPeopleApiService, SnackbarService} from '@tangilla/tg-ng-core';
import { DetailsListWidgetService } from './services/details-list.widget.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'tgf-details-list-widget',
  templateUrl: './details-list.widget.component.html',
  styleUrls: ['./details-list.widget.component.scss']
})

export class DetailsListWidgetComponent extends TangillaQuestion<DetailsListWidgetModel> {
  offices: any[] = [];
  itemsList: any[] = [];
  footer: string = '';
  columns: any[] = [];  
  title: string = '';
  dataQuestionName: string = '';
  showColumnsTitles = false;
  withExpandButton = false;
  isLoading = false;
  detailsListSearchSubscription?: Subscription;

  constructor(
    public memberPeopleApiService: MemberPeopleApiService,
    public officesApiService: OfficesApiService,
    public variablesService: VariablesService,
    private detailsListWidgetService: DetailsListWidgetService,
    private snackbarService: SnackbarService,
    formBuilder: FormBuilder,
    surveyService: SurveyService,
    questionsService: QuestionsService,
    changeDetectorRef: ChangeDetectorRef,
    viewContainerRef?: ViewContainerRef
  ) {
    super(formBuilder,
      surveyService,
      questionsService,
      changeDetectorRef,
      viewContainerRef);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initializeQuestion();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.detailsListSearchSubscription?.unsubscribe();
  }

  initializeQuestion() {
    this.isLoading = true;
    this.changeDetectorRef.detectChanges();  
    this.setJsonObjectValues(); 
    this.setDetailsListSearchObservable();
    this.isLoading = false;
  }

  setJsonObjectValues() {
    if (this.model['jsonObj']) {
      this.dataQuestionName = this.model['jsonObj'].dataQuestionName;
    }
  }
  setDetailsListSearchObservable() {
    if (!this.detailsListWidgetService
      .detailslistSubjects[this.getQuestionName(this.dataQuestionName, this.dataQuestionName)]) {
      this.detailsListWidgetService.setDetailsListQuestionSubject(this.getQuestionName(this.dataQuestionName, this.dataQuestionName));
    }

    this.detailsListSearchSubscription = this.detailsListWidgetService
      .detailslistSubjects[this.getQuestionName(this.dataQuestionName, this.dataQuestionName)]?.detailslistSearch$
      .subscribe({
        next: () =>  {          
            this.setTable();
        }
      });
  }
  setTable() {
    this.isLoading = true;
    const data = this.surveyService.surveyModel.getVariable(this.dataQuestionName);
    if(data) {
      this.itemsList = data.items;
      this.columns = data.columns;
      this.title = data.title;
      this.footer = data.footer;
      this.showColumnsTitles = data.showColumnsTitles ? true : false;
      this.withExpandButton = data.withExpandButton ? true : false;         
    }
    this.isLoading = false;
    this.changeDetectorRef.detectChanges();   
  }

  toggleDetails(item: any) {
    if (!item.details || item.details.detailsCount === 0) {
      return;
    }
    item.showDetails = !item.showDetails;
    this.changeDetectorRef.detectChanges();
  }

  useExpandButton(item: any) {
    return this.withExpandButton && item.detailsCount > 0;
  }

  useWidth(item: any) {
    return this.withExpandButton || item.detailsCount > 0;
  }

  isItLoading() {
    return this.isLoading;
  }
}

RendererFactory.Instance.registerRenderer(
  'details_list',
  'details_list',
  'tg_details_list',
  true
);
AngularComponentFactory.Instance.registerComponent('tg_details_list', DetailsListWidgetComponent);
